import { useEffect, useState } from "react";
import { style } from "./StyleType";
import { Avatar, Brand, NotificationSpan, Wrapper } from "./Style";

interface TmpAvatarCustomProps {
    initials: string;
    size: string;
    image?: string;
    alt?: string;
    notification?: boolean;
    handleClick?: (e: any) => void;
}

export default function TmpAvatarCustom(props: TmpAvatarCustomProps) {
    const [_initials, setInitials] = useState(props.initials);

    useEffect(() => {
        setInitials(props.initials.substring(0, 2).toUpperCase());
    }, [props.initials])

    // Events
    const _handleClick = (e: any) => {
        if (props.size === 'sm' && props.handleClick !== undefined) {
            props.handleClick(e)
        }
    }

    // Passing style props to styled component
    Wrapper.defaultProps = style;
    Avatar.defaultProps = style;
    NotificationSpan.defaultProps = style;
    Brand.defaultProps = style;

    return (
        <Wrapper
            className="tmp-avatar"
            size={props.size}
            onClick={_handleClick}
            data-testid='avatar-wrapper'
        >
            <Avatar size={props.size}>
                {props.image
                    ? <img src={props.image} alt={props.alt} />
                    : _initials
                }
            </Avatar>

            {props.notification && <NotificationSpan data-testid="notification" />}

            {/* { brand && <Brand data-testid="brand"><Logo /></Brand> } */}
        </Wrapper>
    )
}